import { Icon, IIconProps } from 'native-base';
import { Path } from 'react-native-svg';

// EC6E4C
// 464648
export const ClearIcon = ({ size = 'sm', fill = '#464648', ...props }: IIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 100 100" fill="none" {...props}>
      <Path
        d="M0 0 C6.25393821 3.59829508 9.65123834 8.24111492 12.5 14.875 C13.53637052 22.72550672 13.54669688 30.26930072 9.05859375 37.0078125 C4.31462297 42.69106571 -0.41579121 46.43608616 -7.953125 47.24609375 C-15.74386277 47.38235151 -22.47041581 47.34335797 -28.5 41.875 C-29.73046875 39.703125 -29.73046875 39.703125 -30.5 37.875 C-31.16 37.875 -31.82 37.875 -32.5 37.875 C-36.64871047 30.70736182 -37.5264459 24.07619905 -36.5 15.875 C-34.11943845 7.94403826 -28.42147733 3.08807316 -21.5 -1.125 C-14.51216888 -3.45427704 -6.66534364 -3.12719882 0 0 Z "
        fill={fill}
        transform="translate(62.5,28.125)"
      />
    </Icon>
  );
};
